import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CheckCircle } from 'common/images/FaIcons';
import ImportStepIndicator from './ImportStepIndicator';
import {
  Body, Callout, Footer, FooterActions, PrimaryAction
} from './MachineCsv.styled';

function ImportDoneStep({ applied, onDone }) {
  const { t } = useTranslation();
  return (
    <Body>
      <Callout tone="good" role="status">
        <CheckCircle />
        <div>
          <b>
            {t('assets.csv.done.headline', {
              count: applied.changes_applied,
              machines: applied.machines_updated,
              defaultValue: '{{count}} changes applied. Machines updated: {{machines}}.'
            })}
          </b>
          {' '}
          {t('assets.csv.done.detail', {
            defaultValue: 'The asset list has been refreshed, and the change is recorded in the audit log.'
          })}
        </div>
      </Callout>
      <Footer>
        <ImportStepIndicator current="done" />
        <FooterActions>
          <PrimaryAction type="button" onClick={onDone}>{t('common.done', { defaultValue: 'Done' })}</PrimaryAction>
        </FooterActions>
      </Footer>
    </Body>
  );
}

ImportDoneStep.propTypes = {
  applied: PropTypes.shape({
    changes_applied: PropTypes.number.isRequired,
    machines_updated: PropTypes.number.isRequired
  }).isRequired,
  onDone: PropTypes.func.isRequired
};

export default ImportDoneStep;
